import type { SVGProps } from "react";

export function TikTokIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={className}
      {...props}
    >
      <path d="M21 8.6a8.4 8.4 0 0 1-4.9-1.57v7.16a6.31 6.31 0 1 1-5.45-6.25v3.21a3.13 3.13 0 1 0 2.24 3V2h3.21a5.2 5.2 0 0 0 4.9 5.2V8.6Z" />
    </svg>
  );
}
